import { find } from 'lodash-es';

// the difference between this filter and findPermission is that this filter
// deals with the permission objects from the applicationPermissions API
// this will only return the boolean value of "allowed"
export default function FindApplicationPermissionFilter() {
  'ngInject';

  return (permissions, permissionName: string): boolean => {
    let item: any =
      find(permissions, { action: permissionName, allowed: true }) || {};

    return (item as any).allowed || false;
  };
}
